var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"country_show"},[_vm._v("Show Country")])
}
var staticRenderFns = []

export { render, staticRenderFns }